module.exports = __webpack_public_path__ + "img/ico-state.c8fed3df.svg";